import * as React from 'react';
import { AuditNotesV2, AuditNotesTxaV2, useFeatureToggle } from '@css-xp/base';
import { ENABLE_NEW_AUDIT_LOG_TRANSACTION_ACCOUNT } from '@atlassian/cssxp-utils-generic';

export interface AuditTrailProps {
  label: string;
  id: string;
  entityName: string;
}

const AuditTrailTxA = ({ id, entityName, label }: AuditTrailProps) => {
  const [isEnabled] = useFeatureToggle();
  const isNewAuditLogsDataSourceEnabled = isEnabled(ENABLE_NEW_AUDIT_LOG_TRANSACTION_ACCOUNT);
  return (
    <div className="transaction-account-tab" data-testid="transaction-account-audit-trail">
      {!isNewAuditLogsDataSourceEnabled && (
        <AuditNotesV2 id={id} entityName={entityName} label={label} idText={'transaction-account'} />
      )}
      {isNewAuditLogsDataSourceEnabled && (
        <AuditNotesTxaV2 id={id} entityName={entityName} label={label} idText={'transaction-account'} />
      )}
    </div>
  );
};

export default AuditTrailTxA;
